import React, { useState, useEffect, useCallback } from 'react';
import { getDashboardData } from '../services/adminApi';
import StatCard from '../components/admin/dashboard/StatCard';
import SalesChart from '../components/admin/dashboard/SalesChart';
import RecentSales from '../components/admin/dashboard/RecentSales';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Button } from '../components/ui/button';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';
import { subDays } from 'date-fns';

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
  }).format(amount);
};

const AdminDashboardPage = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dateRange, setDateRange] = useState({
    startDate: subDays(new Date(), 30),
    endDate: new Date(),
  });

  const fetchDashboardData = useCallback(async () => {
    try {
      setLoading(true);
      const params = {
        startDate: dateRange.startDate.toISOString(),
        endDate: dateRange.endDate.toISOString(),
      };
      const response = await getDashboardData(params);
      if (response.success) {
        setDashboardData(response.dashboard);
      }
    } catch (error) {
      console.error("Failed to fetch dashboard data", error);
    } finally {
      setLoading(false);
    }
  }, [dateRange]);

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  const handleDateRangeChange = (range) => {
    setDateRange(range);
  };

  return (
    <div className="p-4 md:p-6">
      {loading ? (
        <p>Loading dashboard...</p>
      ) : dashboardData ? (
        <Tabs defaultValue="overview">
          <div className="flex justify-between items-center mb-4">
            <TabsList>
              <TabsTrigger value="overview">Overview</TabsTrigger>
              
            </TabsList>
            <div className="flex gap-2">
                <Button variant="ghost" onClick={() => handleDateRangeChange({ startDate: subDays(new Date(), 90), endDate: new Date() })}>Last 3 months</Button>
                <Button variant="ghost" onClick={() => handleDateRangeChange({ startDate: subDays(new Date(), 30), endDate: new Date() })}>Last 30 days</Button>
                <Button variant="ghost" onClick={() => handleDateRangeChange({ startDate: subDays(new Date(), 7), endDate: new Date() })}>Last 7 days</Button>
              </div>
          </div>
          <TabsContent value="overview">
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
              <StatCard title="Total Revenue" value={formatCurrency(dashboardData.totalRevenue)} />
              <StatCard title="Total Orders" value={dashboardData.totalOrders} />
              <StatCard title="Total Customers" value={dashboardData.totalCustomers} />
              <StatCard title="Total Products" value={dashboardData.totalProducts} />
            </div>
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-7 mt-6">
              <Card className="col-span-4">
                <CardHeader>
                  <CardTitle>Sales</CardTitle>
                </CardHeader>
                <CardContent>
                  <SalesChart data={dashboardData.topSellingProducts} />
                </CardContent>
              </Card>
              <Card className="col-span-3">
                <CardHeader>
                  <CardTitle>Recent Sales</CardTitle>
                </CardHeader>
                <CardContent>
                  <RecentSales data={dashboardData.recentSales} />
                </CardContent>
              </Card>
            </div>
          </TabsContent>
          <TabsContent value="analytics">
            <p>Analytics content goes here.</p>
          </TabsContent>
        </Tabs>
      ) : (
        <p>No data available for the selected date range.</p>
      )}
    </div>
  );
};

export default AdminDashboardPage;
